<template>
  <section class="contact-overview-header">
    <div class="container px-5 md:px-4">
      <h1 class="contact-overview-header__heading">
        {{ i18n.title }}
      </h1>
      <div class="contact-overview-header__contact-options-container">
        <a
          v-if="chatUrl"
          :href="chatUrl"
          class="contact-overview-header__contact-option"
        >
          <chat-bubble class="icon" />
          <h3>{{ i18n.chat.title }}</h3>
          <p>{{ i18n.chat.description }}</p>
        </a>
        <a
          v-if="arrangeUrl"
          :href="arrangeUrl"
          class="contact-overview-header__contact-option"
        >
          <Whatsapp class="icon" />
          <h3>{{ i18n.arrange.title }}</h3>
          <p>{{ i18n.arrange.description }}</p>
        </a>
        <a
          v-if="contactFormUrl"
          :href="contactFormUrl"
          class="contact-overview-header__contact-option"
        >
          <EnvelopeOpen class="icon" />
          <h3>{{ i18n.contactForm.title }}</h3>
          <p>{{ i18n.contactForm.description }}</p>
        </a>
        <a
          v-if="phoneNumber"
          :href="'tel://' + phoneNumber"
          class="contact-overview-header__contact-option"
          @click="openPhoneModal"
        >
          <PhoneOutline class="icon" />
          <h3>{{ i18n.phone.title }}</h3>
          <p>{{ i18n.phone.description }}</p>
        </a>
      </div>
    </div>

    <qr-code-modal
      :title="i18n.phone.modal.title"
      :intro-html="i18n.phone.modal.intro"
      :qr-code-value="phoneNumber"
      :is-open="phoneModal.isOpen"
      @close="closePhoneModal"
    />
  </section>
</template>

<script>
import QrCodeModal from '@/components/QrCodeModal.vue';
import isMobile from 'is-mobile';

export default {
  name: 'ContactOverviewHeader',
  components: {
    ChatBubble: () => import(/* webpackChunkName: "main" */ '@/components/svg/ChatBubble.vue'),
    Whatsapp: () => import(/* webpackChunkName: "main" */ '@/components/svg/Whatsapp.vue'),
    EnvelopeOpen: () => import(/* webpackChunkName: "main" */ '@/components/svg/EnvelopeOpen.vue'),
    PhoneOutline: () => import(/* webpackChunkName: "main" */ '@/components/svg/PhoneOutline.vue'),
    QrCodeModal,
  },
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    arrangeUrl: {
      type: String,
      default: null,
    },
    chatUrl: {
      type: String,
      default: null,
    },
    contactFormUrl: {
      type: String,
      default: null,
    },
    phoneNumber: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      phoneModal: {
        isOpen: false,
      },
    };
  },
  methods: {
    openPhoneModal(clickEvent) {
      if (!isMobile()) {
        clickEvent.preventDefault();
        this.phoneModal.isOpen = true;
      }
    },
    closePhoneModal() {
      this.phoneModal.isOpen = false;
    },
  },
};
</script>

<style lang="postcss">
.contact-overview-header {
  @apply bg-primary-delta pt-20 pb-14;

  &__heading {
    @apply text-center text-black mb-12;
  }

  &__contact-options-container {
    @apply flex flex-wrap justify-center -mb-4;
  }

  &__contact-option {
    @apply w-40 mx-1 mb-4 flex flex-col flex-nowrap items-center text-center;
    color: inherit;

    @screen md {
      @apply mx-5;
    }

    &,
    &:hover,
    &:active {
      text-decoration: none;
    }

    & .icon {
      @apply w-16 h-16 mb-4 text-secondary-alpha transition-colors transition-transform duration-300;
    }

    & h3 {
      @apply mb-3;
    }

    & p {
      @apply whitespace-pre-line;
    }

    &:hover {
      .icon {
        @apply transform scale-110 text-primary-bravo;
      }
    }
  }
}
</style>
